import { Time } from "@angular/common";
import { AgencyMasterProperties } from "./AgencyMasterProperties";
import { BaggageListAirArabia, BookingInfoProperties, BookingPassengerInfoProperties, GalileoBookingProp, MealListAirArabia, SectorInformationProperties, SectorWiseMealProperties, TaxDetailsProperties } from "./BookingPassengerTicketIssuanceProperties";
import { BookingBasicProperties } from "./FlightSearchProperties";
import { PassengerFares } from "./FlightSearchResponseProperties";
import { UsersProperties, UserTicketIssueRightsPCCs } from "./UsersProperties";
export class TicketPaxBaggageSectorSortedProperties {
  sector: string;
  fromAirport: string;
  toAirport: string;
  paxs: TicketSortedPaxs[] = [];
  flightNo: string;
  departureDate: string;
  status: string;
}
export class TicketSortedPaxs {
  passengerID: number;
  passengerType: number;
  paxName: string;
  ticketNo: string;
  passportNo: string;
  mobileNo: string;
  seatNo: string;
  cabin: string;
  checkIn: string;
  meal: string;
}
export class TicketIssuanceProperties{
  agencyOnline = new AgencyMasterProperties();
  userOnline = new UsersProperties();
  bookingInfo = new BookingInfoProperties();
  exchangePassengerBaggage: PassengerBaggageProperties[] = [];
  bookingPassengerInfo: BookingPassengerInfoProperties[] = [];
  sectorInfo: SectorInformationProperties[] = [];
  taxDetails: TaxDetailsProperties[] = [];
  airportCities: AirportCityProperties[] = [];
  passengerBaggage: PassengerBaggageProperties[] = [];
  bookingStatus: string;
  ticketAirlineProperties: TicketAirlineProperties[] = [];
  buttonsProperties= new buttonpropertiesforticketissueance();
  pnrLocalMsg:string;
}
export class buttonpropertiesforticketissueance {
  ticketissuebtn: boolean;
  voidbtn: boolean;
  refundbtn: boolean;
  cancelbtn: boolean;
  ancibtn: boolean;
  ssrIssueTicketbtn: boolean;
  modifybtn: boolean;
}

export class PassengerInfoProperties {
  passengerType: string;
  passengerID: number;
  title: string = "";
  passengerName: string = "";
  paxGender: string = "";
  paxDOB: Date;
  paxNationality: string = "";
  paxIsLead: boolean;
  passportNumber: string = "";
  countryOfIssuance: string = "";
  passportValidFrom: Date;
  passportValidTo: Date;
  serviceType: number;
  serviceSubType: number;
  //ffNo: string = "";
  mobile: string;
  phone: string;
  email: string;
  pNR_Doc: string = "jkl098yrt";
  ticketNo: string = "tkt567e";
  tktBookingDate: Date = new Date("2022-4-13");
  travelingDate: Date = new Date("2022-4-16");
  sector: string;
  supplierCode: string = "TH675Y";
  iATACode: number = 0;
  airlineCode: string = "AD675";
  tripType: string = "Vi";
  conj_Option: boolean;
  conj_TktNo: string = "ConjTKT";
  exchange_TktNo: string = "ex876vb";
  exchange_Option: boolean;
  exchange_TktFee: number = 0;
  debitStatus: number = 0;
  paymentMode: number = 0;
  bookingID: string;
  issuanceID: string = "id987kl";
  bookingPccCode: string = "hjk678";
  issuancePccCode: string = "hjk678a";
  itineraryNo: string = "no6754";
  iATAInvoiceNo: string = "8756";
  mainSupplierID: string = "id7865";
  sellerID: string = "id7865";
  buyerID: string = "id7865";
  costFromAmount: number = 0;
  costFromCurrency: number = 0;
  costExchangeRate: number = 0;
  baseCurrency: string = "AUD";
  exchangeCurrency: string = "PKR";
  baseFare: number = 0;
  totalTaxes: number = 120.0000;
  markup: number = 0;
  netFromCustomer: number = 0;
  netToSupplier: number = 0;
  region: string = "MENA";
  bookingInfoID: number = 0;
  modifiedDateTime: Date;
  baggageCheckIn: number = 5;
  baggageCabin: number = 5;
  supplierRemarks: string = "Ok";
  sectorInformationProperties: SectorInformationProperties[] = [];
  taxDetailsProperties: TaxDetailsProperties[] = [];
}




export class AirportCityProperties {
  fromICAO: string;
  fromIATACODE: string;
  fromAirportName: string;
  fromCity: string;
  fromCountry: string;
  toICAO: string;
  toIATACODE: string;
  toAirportName: string;
  toCity: string;
  toCountry: string;
  passengerID: number;
}
export class PassengerBaggageProperties {
  passengerID: number;
  passengerName: string;
  passengerType: number;
  ticketNo: string;
  baggageCheckIn: number;
  baggageCabin: number;
  status: string;
  toAirport: string;
  fromAirport: string;
  email: string;
  mobile: string;
  mobileSecondary: string;
  passportexpiry: string;
  dob: string;
  gender: string;
  passportno: string;
  title: string;
  firstName: string;
  lastName: string;
  typeName: string;
  seatNum: string;
  meal: string;
}
export class TicketPnrRights {
  issueTicket: boolean = false;
  issuePnr: boolean = false;
  importPNR: boolean = false;
  cancelTicket: boolean = false;
  cancelPnr: boolean = false;
  voidTicket: boolean = false;
  /* exchange: boolean = false;*/
  refund: boolean = false;
  reprice: boolean = false;
  offlinebooking: boolean = false;
  offlinereissue: boolean = false;
  offlineIssue: boolean = false;
  offlineVoid: boolean = false;
  offlineCancel: boolean = false;
  offlinerefund: boolean = false;
  userTicketIssueRightsPCCs: UserTicketIssueRightsPCCs;
}
export class VoidTicketProperties {
  bookingobj: BookingInfoProperties;
  Tickets: string[] = [];

    }
export class TicketDataRequest {
  bookingID: number;
  agencyId: string;
  userId: number;
}
export class TicketAirlineProperties {
  airlinePrefixCode: string;
  airlineLegalName: string;
  airlineLogo: string;
}
export class OfflineToOnlineProperties {
  RequestTypeIdOffline: string;
  AgencyTicketReqFromOffline: string;
  TicketIssueReqFromOffline: boolean;
  VoidReqFromOffline: boolean;
  PNRReqFromOffline: boolean;
  RefundReqFromOffline: boolean;
  OfflineId: number;
}

export class AncillaryQuotes {
  flights: FlightAR[];
}

export class FlightAR {
  segments: Segments;
  legs: Leg[];
}

export class Leg {
  lfID: string;
  pfID: string;
  depDate: string;
  origin: string;
  dest: string;
  serviceQuotes: ServiceQuote[];
  flightNum: string;
}

export class FlyDubaiAnxiHandling {
  retrievePNRResponse: string = "";
  flyDubaiAnxiResponse: FlyDubaiAnxiResponse[];
  transactionIdentifier: string = "";
  currencyCriteriaThatApplied: string = "";
  byDefaultCurrencyRate: number = 0;
}

export class FlyDubaiAnxiResponse {
  ancillaryQuotes: AncillaryQuotes;
  exceptions: any[];
}

export class Segments {
  lfID: string;
  depDate: string;
  origin: string;
  dest: string;
  serviceQuotes: ServiceQuote[];
}

export class ServiceQuote {
  code: string;
  categoryID: number;
  cutoffHours: number;
  currency: string;
  description: string;
  amount: number;
  redeemMiles: number;
  ruleID: string;
  ruleDesc: string;
  maxCountFlightLevel: number;
  maxCountServiceLevel: number;
  quantity: number;
}
